/** API case-request category: Civil Division - Advise */
export const CIVIL_ADVISE_CATEGORY_ID = '926f478b-3124-4a44-b7ac-12b32fb2df4b';
export const CIVIL_ADVISE_CATEGORY_CODE = 'CIVIL_ADVISE';
export const FILE_CATEGORY_CIVIL_ADVISE = 'Civil Division - Advise';

export const CIVIL_ADVISE_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Timeline' },
  { n: 3, lbl: 'Submission & Physical File Delivery' },
  { n: 4, lbl: 'Upload Documents' },
] as const;

export type CivilAdviseWizardStep = (typeof CIVIL_ADVISE_WIZARD_STEPS)[number]['n'];
